export default __webpack_public_path__ + "static/media/spark_52.f9310f1a.png";